import { serializingManga } from "@/mocks/manga";
import SectionHeader from "./SectionHeader";

export default function Updates() {
  // 按更新时间倒序取前 8 条今日/近期更新
  const updates = [...serializingManga].slice(0, 8);

  return (
    <section id="updates" className="bg-background-100 py-12 md:py-16">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="grid gap-10 lg:grid-cols-[1.6fr_1fr]">
          <div>
            <SectionHeader
              tag="最新话更新"
              title="今日最新更新"
              desc="最新话发布后第一时间同步，追更进度实时刷新，再也不用担心错过热门的续章。"
            />
            <ol className="relative space-y-1 border-l-2 border-primary-200 pl-6">
              {updates.map((m) => (
                <li key={m.id} className="relative py-3">
                  <span className="absolute -left-[31px] top-5 h-3 w-3 rounded-full bg-primary-500 ring-4 ring-background-100"></span>
                  <a
                    href="#serializing"
                    className="group flex flex-col gap-1 rounded-md bg-background-50 p-3 transition hover:bg-primary-50 sm:flex-row sm:items-center sm:justify-between"
                    title={`${m.title} 最新话 ${m.latestChapter}`}
                  >
                    <div className="flex min-w-0 items-center gap-3">
                      <img
                        src={m.cover}
                        alt={`${m.title} 封面`}
                        className="h-12 w-9 shrink-0 rounded object-cover object-top"
                        loading="lazy"
                      />
                      <div className="min-w-0">
                        <p className="truncate text-sm font-semibold text-foreground-950 group-hover:text-primary-700">
                          {m.title}
                        </p>
                        <p className="truncate text-xs text-foreground-500">
                          更新至：{m.latestChapter}
                        </p>
                      </div>
                    </div>
                    <div className="flex shrink-0 items-center gap-3 pl-12 sm:pl-0">
                      <span className="whitespace-nowrap rounded-full bg-accent-100 px-2.5 py-1 text-xs text-accent-800">
                        {m.updateTime}
                      </span>
                      <span className="hidden text-xs text-foreground-400 sm:inline">立即阅读</span>
                    </div>
                  </a>
                </li>
              ))}
            </ol>
          </div>

          <aside className="lg:pt-2">
            <div className="sticky top-24 overflow-hidden rounded-lg bg-background-50 ring-1 ring-background-200">
              <div className="relative h-40">
                <img
                  src="https://readdy.ai/api/search-image?query=warm%20flat%20illustration%20of%20a%20sparkling%20notification%20bell%20with%20comic%20bubble%20and%20speedy%20update%20symbols%20on%20a%20paper%20textured%20background%2C%20vermilion%20red%20and%20amber%20gold%20color%20palette%2C%20minimal%20clean%20vector%20style&width=800&height=360&seq=updates-banner&orientation=landscape"
                  alt="最新话更新提醒插图"
                  className="h-full w-full object-cover object-center"
                  loading="lazy"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/60 to-transparent"></div>
                <p className="absolute bottom-3 left-4 right-4 font-heading text-lg text-background-50">
                  追更提醒，不错过任何一话
                </p>
              </div>
              <div className="p-5">
                <p className="text-sm leading-relaxed text-foreground-600">
                  收藏你正在追的连载，最新话一旦更新，更新状态与追更进度会同步显示在这边的提醒里，点开即知、续看直接跳转到上次读到的位置。
                </p>
                <a
                  href="#serializing"
                  className="mt-4 inline-flex w-full items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-4 py-2.5 text-sm font-medium text-background-50 transition hover:bg-primary-600"
                >
                  <i className="ri-bookmark-line"></i>
                  收藏并开启追更
                </a>
              </div>
            </div>
          </aside>
        </div>
      </div>
    </section>
  );
}